export const fetchWithAuth = async (url, options = {}) => {

  const headers = {
    "Cache-Control": "no-cache",
    "Access-Control-Allow-Origin": `${process.env.REACT_APP_API_URL}`,
    ...options.headers,
  };

  const updatedOptions = {
    credentials: "include",
    ...options,
    headers,
  };

  const response = await fetch(url, updatedOptions);

  if (!response.ok) {
    if (response.status === 401) {
      console.error('Unauthorized, redirecting...');
    }
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

export function utilsDatetime() {
  const timestamp = Date.now();
  const date = new Date(timestamp);
  const humanReadableDate = date.toLocaleString();
  return humanReadableDate
}  